import ModalGroup from './ModalGroup';

export default ModalGroup;
